import CryptoJS from "crypto-js";

export const prepareWholeMenuItems = (menu) => {
  const wholeMenuItems = [];
  const recommendedItems = [];
  const popularItems = [];
  menu?.forEach((menuCats) => {
    menuCats?.menu_categories?.forEach((foodCats) => {
      foodCats?.items?.forEach((item) => {
        const tags =
          item?.tags?.length > 0
            ? Array.isArray(item?.tags[0]?.targetitems)
              ? item?.tags[0]?.targetitems
                  .map((item) => {
                    return item?.title;
                  })
                  .join("")
              : item?.tags[0]?.targetitems?.title
            : "";
        let ingredients;
        if (item?.ingredients?.targetitems?.length > 1) {
          ingredients = item?.ingredients?.targetitems
            ? item?.ingredients?.targetitems
                .map((item) => {
                  return item?.ingredientName;
                })
                .join("")
            : "";
        } else {
          ingredients = item?.ingredients?.targetitems
            ? item?.ingredients?.targetitems?.ingredientName
            : "";
        }

        const searchText = item?.name + item?.description + tags + ingredients;
        const obj = {
          ...item,
          searchText,
        };
        if (obj.searchText.toLowerCase().search("recommended") != -1) {
          recommendedItems.push(obj);
        }
        if (obj.searchText.toLowerCase().search("popular") != -1) {
          popularItems.push(obj);
        }
        wholeMenuItems.push(obj);
      });
    });
  });
  return { wholeMenuItems, recommendedItems, popularItems };
};

export const prepareLanguageList = (Languages) => {
  return Languages.map((ln) => {
    let obj = {};

    switch (ln) {
      case "en":
        obj.key = ln;
        obj.val = "English";
        break;
      case "ru":
        obj.key = ln;
        obj.val = "Russian";
        break;
      case "ar":
        obj.key = ln;
        obj.val = "Arabic";
        break;
      case "zh":
        obj.key = ln;
        obj.val = "Chinese";
        break;
      case "de":
        obj.key = ln;
        obj.val = "German";
        break;
      case "ar":
        obj.key = ln;
        obj.val = "Arabic";
        break;
      case "fr":
        obj.key = ln;
        obj.val = "French";
        break;
      case "jp":
        obj.key = ln;
        obj.val = "Japanese";
        break;
      case "sp":
        obj.key = ln;
        obj.val = "Spanish";
        break;
      case "cn":
        obj.key = ln;
        obj.val = "Chinese";
        break;
      default:
        obj.key = ln;
        obj.val = "English";
        break;
    }
    return obj;
  });
};

export const restaurantClose = async (menu, activemMenuIndex) => {
  let myDate = new Date();
  let currentDate = new Date(
    `01/01/2000 ${myDate.getHours()}:${myDate.getMinutes()} `
  );

  let openTime = menu[activemMenuIndex].work_timings[0].open_time;
  let closeTime = menu[activemMenuIndex].work_timings[0].close_time;

  if (closeTime.split(":")[0]?.length < 2) {
    closeTime = "0" + closeTime;
  }
  if (openTime.split(":")[0]?.length < 2) {
    openTime = "0" + openTime;
  }

  if (openTime > closeTime) {
    console.log(
      currentDate,
      new Date(`01/01/2000 ${openTime}`),
      currentDate < new Date(`02/01/2000 ${closeTime}`)
    );
    if (
      (currentDate > new Date(`01/01/2000 ${openTime}`) ||
        currentDate < new Date(`01/01/2000 ${closeTime}`)) &&
      currentDate < new Date(`02/01/2000 ${closeTime}`)
    ) {
      return false;
    } else {
      return true;
    }
  } else {
    // alert("not JETPDR")
    if (
      currentDate > new Date(`01/01/2000 ${openTime}`) &&
      currentDate < new Date(`01/01/2000 ${closeTime}`)
    ) {
      return false;
    } else {
      return true;
    }
  }
};

export const encription = (value) => {
  var key = "6Le0DgMTEmenuNokdEEial"; //length=22
  var iv = "mHGFxENEmenuenLyANoi.e"; //length=22

  key = CryptoJS.enc.Base64.parse(key); // length=16 bytes
  iv = CryptoJS.enc.Base64.parse(iv); // length=16 bytes

  return CryptoJS.AES.encrypt(value, key, {
    iv: iv,
  }).toString();
};

export const decription = (value) => {
  var decryptkey = "6Le0DgMTEmenuNokdEEial"; //length=22
  var decryptiv = "mHGFxENEmenuenLyANoi.e123"; //length=25

  decryptkey = CryptoJS.enc.Base64.parse(decryptkey); // length = 16 bytes
  decryptiv = CryptoJS.enc.Base64.parse(decryptiv); // length = 18 bytes

  return CryptoJS.AES.decrypt(value, decryptkey, {
    iv: decryptiv,
  }).toString(CryptoJS.enc.Utf8);
};
